import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { API } from "../lib/api";

const field =
  "w-full bg-[#0A0A0A] border border-[#27272A] rounded-sm px-3 py-2.5 text-sm text-[#F5F5F5] placeholder:text-[#6b6b6b] outline-none focus:ring-1 focus:ring-[#D4AF37] transition-colors";
const labelCls = "text-xs uppercase tracking-[0.18em] text-[#A3A3A3] mb-1.5 block";

export const ApplicantDialog = ({ open, onOpenChange }) => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Please share your name and email.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/applicants`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error();
      toast.success("Application received. Our team will review and be in touch.");
      setForm({});
      onOpenChange(false);
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="bg-[#141414] border border-[#27272A] text-[#F5F5F5] max-w-lg"
        data-testid="applicant-dialog"
      >
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-light">
            Become a Fallen Angel
          </DialogTitle>
          <DialogDescription className="text-[#A3A3A3]">
            A brief pre-screening for aspiring models. You must be 18 or older.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className={labelCls}>Full Name</label>
              <input className={field} value={form.name || ""} onChange={set("name")} data-testid="applicant-name" />
            </div>
            <div>
              <label className={labelCls}>Email</label>
              <input className={field} type="email" value={form.email || ""} onChange={set("email")} data-testid="applicant-email" />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className={labelCls}>Phone</label>
              <input className={field} value={form.phone || ""} onChange={set("phone")} data-testid="applicant-phone" />
            </div>
            <div>
              <label className={labelCls}>Age</label>
              <input className={field} value={form.age || ""} onChange={set("age")} data-testid="applicant-age" />
            </div>
            <div>
              <label className={labelCls}>Location</label>
              <input className={field} value={form.location || ""} onChange={set("location")} data-testid="applicant-location" />
            </div>
          </div>
          <div>
            <label className={labelCls}>Social / Portfolio</label>
            <input className={field} value={form.social || ""} onChange={set("social")} data-testid="applicant-social" />
          </div>
          <div>
            <label className={labelCls}>Experience</label>
            <input className={field} value={form.experience || ""} onChange={set("experience")} data-testid="applicant-experience" />
          </div>
          <div>
            <label className={labelCls}>Tell us about yourself</label>
            <textarea className={field} rows={3} value={form.about || ""} onChange={set("about")} data-testid="applicant-about" />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#D4AF37] text-[#0A0A0A] font-semibold py-3 rounded-sm hover:bg-[#F3E5AB] transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
            data-testid="applicant-submit"
          >
            {loading && <Loader2 size={16} className="animate-spin" />}
            Submit Application
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default ApplicantDialog;
